// extracted by mini-css-extract-plugin
export var button = "_fx-0";
export var donut = "_fx-1";
export var donutFill = "_fx-3";
export var donutTrack = "_fx-2";